import React, { useState } from "react";

import { useDispatch } from "react-redux";
import { UpgradePlan } from "../../apis/api/MembershipApi";
import Cookies from "js-cookie";
import { toast } from 'react-toastify';

const MembershipPlan = ({ plan,  bgClass }) => {

    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);
    const company_id=Cookies.get("company_id")
    const userID=Cookies.get("userID")
    const tempDiv = document.createElement("div");
  tempDiv.innerHTML = plan.description.replace(/&nbsp;/g, "");
  const descriptionListItems = Array.from(tempDiv.querySelectorAll("li")).map(
  (li, index) => ( 
    <li
      key={`desc-${index}`}
      className="list-group-item"
      dangerouslySetInnerHTML={{ __html: li.innerHTML }}
    />
  )
);

  const allItems = [
    ...descriptionListItems,
  ];

  const Upgrade= async (membership_id)=>{

      const response=await dispatch(UpgradePlan({company_id,membership_id,userID}))
      if(response.payload.status=='success'){
        toast.success(response.payload.msz);
      }else{
        toast.error(response.payload.msz);
      } 
  }

  


  

    return (
  
      <div className="col" key={plan.id}>
        <div className="card mb-5 mb-lg-0">
          <div className={`card-header ${bgClass} py-3`}>
            <h5 className="card-title text-white text-uppercase text-center">
              {plan.membership_name}
            </h5>
            <h6 className="card-price text-white text-center">
              ${plan.fees}
              <span className="term"> Months: {plan.duration_in_months}</span>
            </h6>
          </div>
          <div className="card-body">
          <ul className="list-group list-group-flush mb-2">
     
      {allItems.slice(0, 4)}

      {visible && (
        <>
          {allItems.slice(4)} {/* Remaining items from plan.description */}
        </>
      )}
    </ul>
  
            <div className="text-center mb-4">
              <button
                className="btn btn-link p-0 my-2 fw-bolder"
                style={{ color: bgClass.includes("danger") ? "red" : bgClass.includes("warning") ? "orange" : "blue" }}
                onClick={() => setVisible(!visible)}
              >
                {visible ? "Hide Details" : "View More"}
              </button>
            </div>
              {plan.current_plan==0 ? (
                <div className="d-flex justify-content-center mt-auto">
                  {plan.plan_type==0 ?(
              <button className={`btn btn-sm btn-outline-${bgClass.split("-")[1]} mb-2 d-block w-75`} onClick={()=> Upgrade(plan.membership_id)}>
                Downgrade Plan!
              </button>
                  ):(
              <button className={`btn btn-sm btn-outline-${bgClass.split("-")[1]} mb-2 d-block w-75`} onClick={()=> Upgrade(plan.membership_id)}>
                Upgrade Plan!
              </button>
                  )}
              
            </div>
              ):(
                <div className="d-flex justify-content-center mt-auto">
              Current Plan!
            </div>
              )}
            
          </div>
        </div>
      </div>




       
    );
  };
  export default MembershipPlan